import React from "react";
import styles from "./styles.m.css";
import { Link } from "@quintype/components";
import wretch from "wretch";

const API_URL = "/api/v1/collections/trending-at-vikatan";

export default class TrendingNews extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: []
    };
  }

  componentDidMount() {
    const url = `${API_URL}`;

    wretch(url)
      .get()
      .json(res => {
        const data = res.items;
        this.setState({ data });
      });
  }

  render() {
    return (
      <div className="container">
        <div className={styles["numbered-items-wrap"]}>
          <h2 className={styles["numbered-items-title"]}>TrendingNews</h2>
          <ul className={styles["numbered-items"]}>
            {this.state.data.splice(0, 4).map(late => (
              <li key={late.id} className={styles["numbered-item"]}>
                <Link className={`${styles["numbered-item-link"]}`} href={`${late.story.url}`}>
                  {late.story.headline}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div />
      </div>
    );
  }
}

export { TrendingNews };
